import { KB_COPY } from "@/lib/kb-copy";

/** RawSource.status → 小白可读中文标签 */
export function rawSourceStatusLabel(status: string): string {
  switch (status) {
    case "received":
      return KB_COPY.inboxStatusReceived;
    case "unsupported":
      return KB_COPY.inboxStatusUnsupported;
    case "queued":
      return KB_COPY.inboxStatusQueued;
    case "ingested":
      return KB_COPY.inboxStatusIngested;
    case "failed":
      return KB_COPY.inboxStatusFailed;
    default:
      return status;
  }
}

export type RawSourceStatusTone = "muted" | "warning" | "success" | "primary";

export function rawSourceStatusTone(status: string): RawSourceStatusTone {
  switch (status) {
    case "queued":
      return "warning";
    case "ingested":
      return "success";
    case "failed":
      return "warning";
    default:
      return "muted";
  }
}

export function rawSourceDisplayTitle(raw: {
  id: number;
  title: string | null;
  filename?: string | null;
}): string {
  return raw.title || raw.filename || `资料 #${raw.id}`;
}
